<div class="general-container flex flex-col justify-center items-center" *ngIf="step === 1">
    <div *ngIf="step === 1" class="container header md:w-[66%] md:max-w-[480px]">
        <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px] text-center bg-gradient-2-text" *ngIf="side === 'recover'">E-mail</h2>
        <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px] text-center bg-gradient-2-text" *ngIf="side === 'change'">{{ 'pwd.password' | translate }}</h2>
        <p class="font-sans text-center text-xl text-gray-40" *ngIf="side === 'recover'">{{ 'pwd.need' | translate }}</p>
        <p class="font-sans text-center text-xl text-gray-40" *ngIf="side === 'change'">{{ 'pwd.recover' | translate }} {{ 'REGISTER.PWD_MAX_LENGTH' | translate }}.</p>
    </div>
    <div *ngIf="step === 1" class="md:w-[66%] md:max-w-[380px] mt-24">
        <form *ngIf="side === 'recover'" [formGroup]="emailForm">
            <div class="flex flex-col gap-24">
                <fun-input
                *ngIf="side === 'recover' && email === undefined"
                placeholder="E-mail"
                [parentForm]="emailForm"
                [formControlKeys]="formControlKeys"
                [errorMessages]="errorMessages"
                [isSubmit]="isSubmit"
                controlName="email"
                type="text"
                [errorLogin]="errorMail"
                labelName="E-mail"
                    ></fun-input>
                <p class="block w-full font-sans text-eggplant-80 border border-eggplant-75 rounded
                    shadow-dimension placeholder:font-sans placeholder:text-l placeholder:text-eggplant-55
                    bg-cream-100/[.10] mt-6 py-12 pl-12 pr-28" *ngIf="side === 'recover' && email !== undefined">{{ email }}</p>
            </div>
        </form>
        <form *ngIf="side === 'change'" [formGroup]="passwordForm">
            <div class="flex flex-col gap-24">
                <fun-input
                *ngIf="side === 'change'"
                placeholder="**********"
                [parentForm]="passwordForm"
                [formControlKeys]="formControlKeys"
                [errorMessages]="errorMessages"
                [isSubmit]="isSubmit"
                controlName="pwd1"
                type="password"
                [errorLogin]="errorPwd1"
                labelName="{{ 'pwd.new_pwd' | translate }}"
                ></fun-input>
                <fun-input
                class="second-inp"
                *ngIf="side === 'change'"
                placeholder="**********"
                [parentForm]="passwordForm"
                [formControlKeys]="formControlKeys"
                [errorMessages]="errorMessages"
                [isSubmit]="isSubmit"
                controlName="pwd2"
                type="password"
                [errorLogin]="errorPwd2"
                labelName="{{ 'pwd.repeat_pwd' | translate }}"
                ></fun-input>
            </div>
        </form>
    </div>
</div>
<div class="done flex flex-col items-center justify-center md:w-[66%] md:max-w-[380px] h-full" *ngIf="step === 3">
    <img *ngIf="side === 'recover'" src="../../../../../assets/images/img/rocket.svg" alt="e-mail">
    <img *ngIf="side === 'change'" src="../../../../../assets/images/img/rocket.svg" alt="e-mail">
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px] text-center" *ngIf="side === 'recover'">{{ 'pwd.sent' | translate }}</h2>
    <h2 class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px] text-center" *ngIf="side === 'change'">{{ 'pwd.restored' | translate }}</h2>
    <p class="font-sans text-center text-xl text-gray-40" *ngIf="side === 'recover'">{{ 'pwd.check' | translate }}</p>
    <p class="font-sans text-center text-xl text-gray-40" *ngIf="side === 'change'">{{ 'pwd.invest' | translate }}</p>
    <fun-new-button *ngIf="side === 'change'" [buttonType]="'primaryDark'" [size]="'2xl'" [classExtra]="' !w-full mt-40 '" title="{{ 'btn.access' | translate }}" (eventClick)="viewprojects()" [iconVibibleMobile]="false"></fun-new-button>
</div>
<div class="footer flex flex-col-reverse py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row justify-between md:border-t md:border-eggplant-10 gap-8" *ngIf="step === 1">
  <div class="md:flex justify-center items-center">
    <fun-new-button [buttonType]="'ghost'" icon="arrow-left" [iconPosition]="'left'" [classExtra]="' !w-full '" title="{{ 'btn.back' | translate }}" size="xl" (eventClick)="prev()" [iconVibibleMobile]="false"></fun-new-button>
  </div>
  <div class="w-full md:w-fit md:flex justify-center content-center">
    <fun-new-button [buttonType]="'primaryDark'" icon="arrow-right" [iconPosition]="'right'" [classExtra]="' !w-full '" title="{{ 'btn.send' | translate }}" size="xl" (eventClick)="submit()" [iconVibibleMobile]="false" [responsive]="false"></fun-new-button>
  </div>
</div>
<div *ngIf="step === 2" class="h-full flex flex-col justify-center items-center">
    <fun-skeleton-list></fun-skeleton-list>
</div>